export const transform = (item) => {
  return {
    id: item.id?.toString(),
    title: item.title,
    type: item.type,
    description: item.description,
    year: item.year,
    imageUrl: item.imageUrl,
    isClubAward: !!item.clubAward,
    isRankAward: !!item.rank,
    isDefaultAward: !!item.defaultAward,
  }
}

export const transformMany = (items) => {
  return items.map((item) => transform(item))
}

export const transformUserWinner = (item) => {
  return {
    id: item.id,
    name: item.name,
    email: item.email,
    status: item.status,
    photoUrl: item.photoUrl,
    officeName: item.primaryOfficeName,
    officeCity: item.primaryOfficeCity,
    officeState: item.primaryOfficeState,
    officeZip: item.primaryOfficeZip,
    officeWebsite: item.primaryOfficeWebsite,
    rankOrder: item.rankOrder,
    winnerType: 'user',
  }
}

export const transformManyUserWinners = (items) => {
  return items.map((item) => transformUserWinner(item))
}

export const transformOfficeWinner = (item) => {
  return {
    id: item.id,
    officeName: item.tradeName,
    officeAddress: item.addressStreet,
    officeCity: item.city,
    officeState: item.state,
    officeZip: item.zipCode,
    officeWebsite: item.website,
    primaryOwnerName: item.primaryOwnerName,
    rankOrder: item.rankOrder,
    winnerType: 'office',
  }
}

export const transformAwardWinners = (items, type = 'user') => {
  if (type.toLowerCase() === 'office') {
    return items.offices?.map((item) => transformOfficeWinner(item))
  }

  if (type.toLowerCase() === 'user') {
    return items.users?.map((item) => transformUserWinner(item))
  }
}
